export default {
  products: [],
  savedProduct: {},
  deleteProduct: {},
};
